<template>
  <div class="list">
    <div class="item" v-for="(v, i) in list" :key="i">
      <div class="top" @click="() => toDetail(v.categoryId)">
        <img
          class="bg"
          :src="
            v.iconUrl ||
            'https://ossuat.plantmate.com/commonAttachment/1739239507840/%E8%87%AA%E5%8A%A8%E5%8C%96%E6%9C%BA%E6%A2%B0%401x%20%281%29.png'
          "
        />
        <div class="des">
          <h2>{{ v.categoryName }}</h2>
          <span>{{ v.des || '热卖' }}</span>
        </div>
        <a href="javascript:" class="arrow">
          <img src="~@/assets/img/premium/arrow.png" />
        </a>
      </div>
      <div class="brand-wrap">
        <div class="brand">
          <Item :brands="v.brands" :categoryId="v.categoryId + ''" />
          <!-- <div
            class="brand-item"
            v-for="(v2, i2) in Math.ceil(v.brands.length / 2)"
            :key="i2"
          >
            <div @click="() => toDetail(v.categoryId, v.brands[2 * (v2 - 1)])">
              <img :src="v.brands[2 * (v2 - 1)].brandLogo" />
              <div class="brand-title">
                {{ v.brands[2 * (v2 - 1)].name }}
              </div>
            </div>
            <div
              @click="() => toDetail(v.categoryId, v.brands[2 * (v2 - 1) + 1])"
              v-if="v.brands[2 * (v2 - 1) + 1]"
            >
              <img :src="v.brands[2 * (v2 - 1) + 1].brandLogo" />
              <div class="brand-title">
                {{ v.brands[2 * (v2 - 1) + 1].name }}
              </div>
            </div>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Item from './brandItem.vue'
export default {
  components: {
    Item
  },
  props: {
    list: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    toDetail (categoryId, v) {
      let query = {
        foregroundCategoryId: categoryId,
        brandIdList: v && v.brandId ? v.brandId : '',
        seriesIdList: '',
        attributeValueIdList: '',
        salesDesc: false,
        priceDesc: false,
        popularityDesc: false,
        category: true
      }
      let queryStr = Object.keys(query)
        .map((v) => `${v}=${query[v]}`)
        .join('&')
      window.open('/premiumGoodCategoryList?' + queryStr)

      // this.$router.push({
      //   path: '/premiumGoodCategoryList',
      //   query: {
      //     foregroundCategoryId: categoryId,
      //     brandIdList: v && v.brandId ? v.brandId : '',
      //     seriesIdList: '',
      //     attributeValueIdList: '',
      //     salesDesc: false,
      //     priceDesc: false,
      //     popularityDesc: false,
      //     category: true
      //   }
      // })
    }
  }
}
</script>

<style lang="scss" scoped>
.list {
  display: flex;
  flex-wrap: wrap;
  width: 1200px;
  margin: 30px auto;
  .item {
    width: calc(50% - 15px);
    margin: 0 15px 15px 0;
  }
}

.top {
  display: flex;
  position: relative;
  height: 77px;
  overflow: hidden;
  cursor: pointer;
  img {
    height: 77px;
    object-fit: contain;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    border-radius: 12px 12px 0 0;
  }
  .des {
    position: absolute;
    left: 120px;
    top: 0;
    color: #3f59a5;
    h2 {
      line-height: 25px;
      font-size: 20px;
      font-weight: bold;
      margin: 0;
      padding: 18px 0 4px;
    }
    span {
      font-size: 12px;
      line-height: 14px;
    }
  }
  .arrow {
    position: absolute;
    right: 20px;
    top: 28.5px;
    z-index: 99;
    display: block;
    width: 24px;
    height: 24px;
    img {
      width: 24px;
      height: 24px;
    }
  }
}

.brand-wrap {
  padding: 20px;
  border-radius: 0 0 12px 12px;
  border: 2px solid #dde3f1;
  border-top: 0;
}

.brand {
  display: flex;
  overflow-x: auto;
  .brand-item {
    margin-right: 20px;
    cursor: pointer;
  }
  img {
    width: 100px;
    height: 100px;
    object-fit: contain;
    border-radius: 12px;
  }
  .brand-title {
    display: block;
    text-align: center;
    font-size: 14px;
    font-weight: 500;
    color: #333333;
    line-height: 19px;
    padding: 4px 0 20px;
  }
}
</style>
